<template>
  <button
    :class="[
      'underlined-button',
      light && 'light',
      mediumLight && 'medium-light',
      accent && 'accent',
      big && 'big',
      small && 'small',
      noUnderline && 'no-underline',
      bold && 'bold',
    ]"
    :disabled="disabled"
    @click="onClick"
    @keydown="handleKeyDown"
    :aria-labelledby="ariaLabel"
    :type="type"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    onClick: Function,
    enterPress: Function,
    ariaLabel: String,
    text: String,
    type: String,
    light: Boolean,
    mediumLight: Boolean,
    accent: Boolean,
    big: Boolean,
    small: Boolean,
    noUnderline: Boolean,
    bold: Boolean,
  },
  methods: {
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.target.blur();
        this.enterPress?.(event);
      }
    },
  },
};
</script>

<style lang="scss">
.underlined-button {
  text-decoration: underline;
  font-size: 1.4rem;
  color: map-get($component-colours, underlined-button-font-colour-dark);
  font-family: $font-secondary;
  background: none;
  padding: 0;
  letter-spacing: 0.01rem;

  &:hover {
    color: lighten(
      map-get($component-colours, underlined-button-font-colour-dark),
      30%
    );
  }

  &:focus-visible {
    box-shadow: 0 0 0 0.3rem rgba(255, 233, 254, 0.4);
    outline: solid 0.2rem rgba(255, 233, 254, 1);
    border: solid 0.1rem map-get($colours, accent-purple3);
  }

  &.light {
    color: map-get($component-colours, underlined-button-font-colour-light);
  }

  &.medium-light {
    color: map-get($colours, grey-3);
  }

  &.accent {
    color: map-get($component-colours, underlined-button-font-colour-accent);
  }

  &.big {
    font-size: 1.6rem;
  }

  &.small {
    font-size: 1.2rem;
  }

  &:disabled {
    color: map-get($colours, grey-3);
  }

  &.no-underline {
    text-decoration: none;
  }
  &.semiBold {
    font-weight: 500;
  }
}
</style>